<template>
  <div class="payment-wrapper text-base">
    <a href="/mein-lidl-connect-v2/meine-daten/zahlungsdaten.html" target="_self" class="change-data-button text-sm">
      <img src="/files/lidl/images/new-icons/svg/pen-outline.svg" alt=""/><span>Zahlungsdaten ändern</span>
    </a>
    <div v-if="!isNoPayment" class="data-grid">
      <div class="col">
        <p class="label">Deine aktuelle Zahlungsart</p>
        <p>{{ isCreditCard ? 'Kreditkarte' : 'Lastschrift' }}</p>
      </div>
      <div class="col">
        <p class="label">{{ isCreditCard ? 'Kreditkarteninhaber' : 'Kontoinhaber' }}</p>
        <p>{{ isCreditCard ? paymentInformation.paymentType.holder : paymentInformation.paymentType.owner }}</p>
      </div>
      <div v-if="isBankAccount" class="col">
        <p class="label">IBAN</p>
        <p class="flex-align-center">
          <span class="iban-number-block">****</span>
          <span class="iban-number-block">****</span>
          <span class="iban-number-block">****</span>
          <span>{{ paymentInformation.paymentType.iban }}</span>
        </p>
      </div>
      <div v-if="isCreditCard" class="data-grid">
        <div class="col">
          <p class="label">Prüfnummern</p>
          <p class="flex-align-center">
            <span class="iban-number-block">****</span>
            <span class="iban-number-block">****</span>
            <span class="iban-number-block">****</span>
            <span>{{ paymentInformation.paymentType.lastDigits }}</span>
          </p>
        </div>
      </div>
    </div>
    <div v-else class="data-grid">
      <div class="col">
        <p class="label">Deine aktuelle Zahlungsart</p>
        <p>Keine Zahlart hinterlegt</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    isNoPayment: {
      default: false
    },
    isCreditCard: {
      default: false
    },
    isBankAccount: {
      default: false
    },
    paymentInformation: {
      default: null
    }
  }
}
</script>
